export default {
  action_to_realize: "Actions à réaliser",
  sign_action: "Enregistrer et signer",
  complete: "Compléter",
  toComplete: "À compléter",
  due_date: "Échéance",
  toSign: "À signer",
  description: "Description",
  yearProgression: "Progression de l'année",
  progression: "Progression",
  your_progression: "Votre taux de remplissage",
  triad_progression: "Taux de remplissage trinôme",
  missions_defined: "Missions définies",
  activities_described: "Activités décrites",
  question: "Question",
  incoming: "En attente",
  signature: "Signature",
  questionnaire: "Questionnaire",
  questionnaires: "Questionnaires",
  yourAnswer: "Votre réponse : ",
  answerHere: "Répondez ici",
  commentHere: "Laissez un commentaire ici",
  comment: "Commenter la réponse",
  answerComment: "Répondre au commentaire",
  sendComment: "Poster le commentaire",
  sign: "Signer",
  draft: "Enregistrer en brouillon",
  sharedDraft: "Partager le brouillon",
  stopSharedDraft: "Arréter de partager le brouillon",
  stopSharedDraft_success: "Le brouillon de ce questionnaire n'est plus partagé",
  downloadPdf: "Télécharger le questionnaire",
  downloadPdfModel: "Télécharger le modèle",
  interviewDate: "Date de visite en entreprise",
  youAnswered: "Vous avez répondu :",
  sendFile: "Envoyer un fichier",
  sendDocument: "Envoyer un document",
  takePicture: "Prendre une photo",
  fileSource: "Source du fichier",
  yesSign: "Oui, je signe",
  questionnaire_remove_title: "Supprimer un questionnaire",
  questionnaire_remove_sub_title: "Êtes-vous sûr de vouloir supprimer ce questionnaire ?",
  copy_questionnaire: "Copier le questionnaire",
  copy_questionnaire_title: "Copie du questionnaire « {title} »",
  questionnaire_copy_success: "Questionnaire copié avec succès !",
  questionnaire_removed_success: "Questionnaire supprimé avec succès !",
  questionnaires_copied: "Versions du questionnaire ci-dessus",
  signMessage:
    "Êtes-vous sûr de vouloir signer le questionnaire ? Vous ne pourrez plus modifier vos réponses par la suite.",
  row_add_success: "Ligne ajoutée avec succès !",
  comment_add_success: "Commentaire ajouté avec succès !",
  deleteMessage: "Êtes-vous sûr de vouloir supprimer cette ligne ?",
  download_report: "Télécharger le rapport",
  signatory: "Signataire",
  signatories: "Signataires",
  expected_signature: "Signature prévue avant le",
  signed_on: "Signé le",
  commented_by: "Commenté par",
  success: "Sauvegardé avec succès !",
  draftSuccess: "Brouillon sauvegardé avec succès !",
  sharedSuccess: "Brouillon partagé avec succès !",
  signedSuccess: "Signé avec succès !",
  missionValidationError:
    "Impossible de signer : veuillez renseigner l'objectif (ou le commentaire si la mission est terminée) pour chaque mission du bloc.",
  activityValidationError:
    "Impossible de signer : veuillez renseigner le commentaire de suivi pour chaque activité du bloc.",
  questionnaireLoadingError: "Une erreur est survenue lors du chargement du questionnaire. Veuillez réessayer.",
  deletedQuestionnaire: "Ce questionnaire a été supprimé",
  addLine: "Ajouter une ligne",
  "Competence calculated by your answers to the questionnaires":
    "Compétence calculée par vos réponses aux questionnaires",
  open_from: "Ouverture du",
  no_crew_dates: "Aucunes dates pour le groupe",
  open_to: "au",
  marks: "Notes",
  block_sign: "Signature du questionnaire possible uniquement après la validation des autres membres du trinôme.",
  no_mark: "Aucune note pour le moment",
  "Download dates": "Télécharger les dates",
  "Print all the questionnaires": "Imprimer l'ensemble des questionnaires",
  answered: "a répondu le",
  remove_answer_title: "Suppression d'une ligne",
  remove_answer: "Êtes-vous sur de vouloir supprimer cette ligne de réponse ?",
  to_be_completed_from: " À renseigner du ",
  to: " au ",
  open_at: "Ouverture le ",
  closed_at: "Clôturé au ",
  reopened: "Questionnaire ré-ouvert",
  signed_at: "Signé le ",
  export_questionnaire: "Exporter le questionnaire",
  import_questionnaire: "Importer un questionnaire",
  no_questionnaire: ({ plural }) =>
    plural([
      "Aucune catégorie n'est renseigné pour cette année",
      "Aucun questionnaire n'est renseigné pour cette catégorie",
    ]),
  empty_comment_label: "Commentaire",
  note: {
    title: ({ plural }) => plural(["Note", "Notes"]),
    question: {
      title: "Note de la question",
    },
    cluster: {
      title: "Note de la grille",
    },
    questionnaire: {
      title: "Notes du questionnaire",
    },
    use_note_for_questionnaire: {
      title: "Intégrer la note dans la note finale du questionnaire",
    },
    coefficient: "Coefficient",
    coefficient_help:
      "Permet de pondérer l'importance de cette grille par rapport aux autres grilles du questionnaire" +
      "\n Exemple : Vous avez 2 grilles" +
      "\n - Grille 'Théorique' avec coefficient 2" +
      "\n - Grille 'Pratique' avec coefficient 3" +
      "\n La grille 'Pratique' comptera 1,5 fois plus dans la note globale",
    coefficient_question_help: "Multiplicateur appliqué à la note finale de cette grille",
    convertion: "Barème de la note finale",
    convertion_help:
      "Définit le barème sur lequel sera reportée la note finale après avoir calculé la moyenne de toutes les questions de cette grille " +
      "\n Exemple : Vous avez 5 questions notées sur 2 points chacune. " +
      "\n - Si vous indiquez 20, la moyenne sera reportée sur 20 " +
      "\n - Si l'apprenant obtient 8/10, sa note finale sera 16/20",
    convertion_question_help: "La note de cette question sera convertie sur ce barème",
    question_conversion: "Barème par question",
    question_conversion_help:
      "Définit le barème d'affichage pour chaque question de cette grille. Les points obtenus ne peuvent pas dépasser les points de la question !" +
      "\n Cas 1 : Question sur 5 points" +
      "\n - Barème par question = 20" +
      "\n Les notes affichées seront: 5/20, 4/20, 3/20, etc (la note reste limitée aux 5 points de la question)." +
      "\n Cas 2 : Questions suir 5 points" +
      "\n Barème par question = 4" +
      "\n Les notes seront plafonnées : 4/4, 3/4, 2/4, etc (les 5 points possibles sont ramenés à 4 maximum)",
    question_conversion_question_help: "Note maximale possible pour cette question",
    see_details: "Voir le détail des notes",
    details: "Détail",
    mark_detail: "Détail des notes",
    average: "Moyenne",
    mark_scale: "Barème",
    maximal_mark: "Note maximale",
    minimal_mark: "Note minimale",
    maximal_mark_upper_than_mark_converted: "La note maximale ne peut pas être supérieure à la note affichée",
    maximal_mark_for_question: "La note maximale pour cette question est de:",
    maximal_mark_with_value: "Note maximale : {mark1}/{mark2}",
    error: {
      no_genral_mark:
        "Le système de notation est activé sur cette question, veuillez également saisir le barème général du questionnaire en cliquant ici",
    },
    leave_empty: "Laisser vide si la note maximale est la même que dans la liste de choix.",
  },
  summary_sheet: {
    title: "Synthèse des notes",
    average: "Moyenne",
  },
  completeness_date_between_triad_start_date_and_end_date:
    "La date de complétude doit être comprise entre les dates d'ouverture et de fermeture des membres du trinômes",
  lock_questionnaire_heading: "Verouiller/déverouiller la position de l'entête",
  questionnaire_focus_scroll: "Défilement automatique vers le champ en cours de saisie",
  use_contract_date: "Ouverture en fonction des dates des contrats actifs des trinômes",
  cluster: {
    required_error: "Attention vous devez renseigner au moins une colonne",
  },
};
